import { Context } from 'effect';
import type { Effect, Layer, Option } from 'effect';

import type { GetAuthTokenError, SetAuthTokenError } from '../../data/error/auth';
import type { CookiesStore } from '../cookies/CookiesStore';
import { ContextTag } from '../context';

/** Cookie-backed authentication port; shell Live implementation stays app-side. */
export type AuthTokenService = {
  readonly getToken: Effect.Effect<Option.Option<string>, GetAuthTokenError>;
  readonly setToken: (token: string) => Effect.Effect<void, SetAuthTokenError>;
  readonly removeToken: Effect.Effect<void, SetAuthTokenError>;
  readonly getRefreshToken: Effect.Effect<Option.Option<string>, GetAuthTokenError>;
  readonly getRefreshTokenExpiration: Effect.Effect<Option.Option<number>, GetAuthTokenError>;
  readonly setTokens: (
    token: string,
    refreshToken: string,
    refreshTokenExpiration: number
  ) => Effect.Effect<void, SetAuthTokenError>;
  readonly removeAllTokens: Effect.Effect<void, SetAuthTokenError>;
};

export class AuthToken extends Context.Service<AuthToken, AuthTokenService>()(
  ContextTag.AuthToken
) {
  declare static Live: Layer.Layer<AuthToken, never, CookiesStore>;
}
